import { FormHelperText } from "@mui/material";
import React, { useMemo } from "react";
import { InputHelperText, Labeled, useInput } from "react-admin";
import { createAjvValidator } from "vanilla-jsoneditor";
import JsonEditor from "./JsonEditor";

const JsonInput = (props) => {
  const {
    source,
    label,
    helperText,
    schema,
    validate,
  } = props;

  const validator = useMemo(
    () => (schema ? createAjvValidator({ schema }) : undefined),
    [schema]
  );

  const combinedValidate = useMemo(() => {
    const existing = validate
      ? Array.isArray(validate)
        ? validate
        : [validate]
      : [];
    if (!validator) return existing;

    const isMetaMessage = (message) =>
      /must match (".*" schema|(exactly one|a) schema in (oneOf|anyOf))/.test(message);

    const schemaValidate = (value) => {
      if (value === null || value === undefined) return undefined;
      const errors = validator(value);
      if (errors && errors.length > 0) {
        const messages = errors
          .filter((e) => !isMetaMessage(e.message))
          .map((e) => `${e.path.join("/") || "/"}: ${e.message}`);

          return (messages.length > 0
          ? messages
          : errors.map((e) => `${e.path.join("/") || "/"}: ${e.message}`)
        ).join("; ");
      }
      return undefined;
    };

    return [schemaValidate, ...existing];
  }, [validator, validate]);

  const {
    field: { value, onChange },
    fieldState: { isTouched, error },
    formState: { isSubmitted },
    isRequired,
  } = useInput({ ...props, validate: combinedValidate });

  const editorOnChange = (updatedContent, previousContent, { contentErrors, patchResult }) => {
    const parseError = contentErrors && "parseError" in contentErrors;
    if (parseError || updatedContent.text === "") {
      onChange(null);
    } else {
      onChange(JSON.parse(updatedContent.text));
    }
  }

  return (
    <div style={{ width: "100%" }}>
      <Labeled
        source={source}
        isRequired={isRequired}
        fullWidth={true}
        label={label}
      >
        {useMemo(() => <JsonEditor
          mode="text"
          mainMenuBar={false}
          onChange={editorOnChange}
          validator={validator}
          content={{text: JSON.stringify(typeof value === "object" ? value : {})}}
        ></JsonEditor>, [])}
      </Labeled>
      <FormHelperText error={(isTouched || isSubmitted) && !!error}>
        <InputHelperText
          touched={isTouched || isSubmitted}
          error={error?.message}
          helperText={helperText}
        />
      </FormHelperText>
    </div>
  );
}

export default JsonInput